import * as React from 'react';
import {
  Box,
  TextField as MuiTextField,
  type TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { forwardRef } from 'react';

import type { BaseComponentProps } from '../utils/types';

export interface TextFieldProps
  extends BaseComponentProps,
    Pick<
      MuiTextFieldProps,
      | 'defaultValue'
      | 'variant'
      | 'value'
      | 'type'
      | 'name'
      | 'autoComplete'
      | 'label'
      | 'placeholder'
      | 'helperText'
      | 'disabled'
      | 'onKeyDown'
      | 'onChange'
      | 'onFocus'
      | 'onBlur'
      | 'onClick'
      | 'error'
      | 'autoFocus'
      | 'fullWidth'
      | 'multiline'
      | 'rows'
      | 'minRows'
      | 'maxRows'
      | 'inputRef'
      | 'select'
      | 'size'
      | 'required'
      | 'children'
      | 'InputProps'
      | 'inputProps'
      | 'title'
    > {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  backgroundColor?: string;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: number;
}

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(
  (
    {
      variant = 'outlined',
      backgroundColor = 'transparent',
      startAdornment,
      endAdornment,
      min,
      max,
      step,
      maxLength,
      InputProps,
      inputProps,
      ...otherProps
    },
    ref,
  ) => {
    return (
      <MuiTextField
        ref={ref}
        sx={{ backgroundColor }}
        variant={variant}
        {...otherProps}
        InputProps={{
          startAdornment,
          endAdornment,
          ...InputProps,
        }}
        inputProps={{
          maxLength,
          min,
          max,
          step,
          ...inputProps,
        }}
      />
    );
  },
);

type TextFieldWrapperProps = {
  my?: number;
};

export const TextFieldWrapper = ({
  children,
  my = 2,
}: React.PropsWithChildren<TextFieldWrapperProps>) => (
  <Box sx={{ my }}>{children}</Box>
);
